import axios from "axios";
import React from "react";
import qs from "query-string";
import { useLocation } from "react-router-dom";

const LoginRedirectPage: React.FC = () => {
  const didEffect = React.useRef(false);
  const location = useLocation();
  const query = qs.parse(location.search);
  const token = (query.token as string) ?? "";
  const erp_token = (query.erp_token as string) ?? "";
  const gotofunc = (query.gotofunc as string) ?? "";

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;

    const f = async () => {
      try {
        const response = await axios.post<{ data: { location: string } }>(
          "/api.d/v1/auth/login-token/login",
          {
            erp_token,
            gotofunc
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log(response);
        // console.log(response.data.data.location);
        const redirectTo = response.data.data.location;
        window.location.href = redirectTo;
      } catch (err) {
        console.error(err);
      }
    };
    f();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};
export default LoginRedirectPage;
